import { InputTemplateOptions } from 'src/app/shared/input-components/components/bs-ng-components';
import { ColOptions } from './ds-col.component';

export class FormOptions {
  public halfCol: ColOptions;
  public fullCol: ColOptions;
  public inputsTemplateOptions: InputTemplateOptions;

  public displayHalfCol: ColOptions;
}
